/* eslint-disable @typescript-eslint/no-explicit-any */
export default function getErrorMessage(
  error: Error | null | undefined,
  data:
    | {
        [key: string]: any;
      }
    | null
    | undefined,
): string | null | undefined {
  if (error) {
    return typeof error.message === 'string' ? error.message : String(error);
  }
  if (data && typeof data.error === 'string') {
    return data.error;
  }
}
